import { ShiftPostStep } from '@features/shift-post-v2/steps'
import { connect } from 'formik'
import { IAcceptanceCriteriaStepProps } from './acceptance-criteria-step.types'
import { WhoCanWorkSection } from './components'
import { AcceptanceCriteriaStepContainer } from './acceptance-criteria-step.styles'

export const AcceptanceCriteriaStep = connect<IAcceptanceCriteriaStepProps>(
  ({ sourcePage }) => {
    return (
      <AcceptanceCriteriaStepContainer>
        <WhoCanWorkSection
          sourceStep={ShiftPostStep.ACCEPTANCE_CRITERIA}
          sourcePage={sourcePage}
        />
      </AcceptanceCriteriaStepContainer>
    )
  },
)
